import { Injectable } from '@angular/core';
import { App, AlertController } from 'ionic-angular';

@Injectable()
export class AlertService {

  constructor(private app: App, private alertCtrl: AlertController) { }

  presentNotStudentAlert() {
    let alert = this.alertCtrl.create({
      title: 'Benötigt Studentenlogin',
      message: 'Ich suche dich ist nur für Studenten ersichtlich, melde dich mit deinem Studentenlogin an, um die Inserate anzuschauen.',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Einloggen',
          handler: () => {
            this.app.getActiveNav().setRoot('login');
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/alert.service.ts